<template>
  <k-panel>
    <template v-slot:left-buttons>
      <k-tabs large>
        <k-tab name="dashboard" to="/billing/dashboard/view" label="Dashboard"></k-tab>
        <k-tab name="billing" to="/billing/billing/list" label="Billing"></k-tab>
        <k-tab name="contracts" to="/billing/contracts/list" label="Contracts"></k-tab>
        <k-tab name="customers" to="/billing/customers/list" label="Customers"></k-tab>
      </k-tabs>
    </template>
    <template #default>
      <div>
        <router-view></router-view>
      </div>
    </template>
  </k-panel>
</template>

<script>

import BillingDashboard from './billing/Dashboard.vue'
import BillingPage from './billing/Billing'
import ContractsPage from './billing/Contracts'
import CustomersPage from './billing/Customers'


export default {
	routes: [
		{
			path: '',
			redirect: 'dashboard'
		},
    {
      path: 'dashboard',
      component: BillingDashboard,
      children: BillingDashboard.routes
    },
  	{
      path: 'billing',
      component: BillingPage,
      children: BillingPage.routes
    },
    {
    	path: 'contracts',
    	component: ContractsPage,
    	children: ContractsPage.routes
    },
    {
    	path: 'customers',
    	component: CustomersPage,
    	children: CustomersPage.routes
    },
   ]
}

</script>
